module.exports = __webpack_public_path__ + "static/customer_badger_logo-e62bc0d60a2f4e5227762fcf6b479a77.svg";